import { BrowserModule } from '@angular/platform-browser';
import { NgModule, isDevMode } from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {ToastrModule} from 'ngx-toastr';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './user/home/home.component';
import { UsermodulesComponent } from './modules/usermodules/usermodules.component';
import { AllmodulesComponent } from './modules/allmodules/allmodules.component';
import { CreateComponent } from './class/create/create.component';
import { DetailsComponent } from './class/details/details.component';
import { FilesComponent } from './class/files/files.component';
import { NotesComponent } from './class/notes/notes.component';
import { VideosComponent } from './class/videos/videos.component';
//import { EditComponent } from './class/edit/edit.component';
import { DashboardComponent } from './user/dashboard/dashboard.component';
import { LoginComponent } from './useraccess/login/login.component';
import { ForgotpasswordComponent } from './useraccess/forgotpassword/forgotpassword.component';
import { RegisterComponent } from './useraccess/register/register.component';
import { UseraccessskinComponent } from './useraccess/useraccessskin/useraccessskin.component';
import { ForumComponent } from './class/forum/forum.component';
import { ForumtemplateComponent } from './class/forumtemplate/forumtemplate.component';
import { ForumService } from './services/forum.service';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import  {  FormsModule,  ReactiveFormsModule  }  from  '@angular/forms';
import { ChangepasswordComponent } from './useraccess/changepassword/changepassword.component';
import { PasswordStrengthComponent } from './shared/password-strength/password-strength.component';
import { ConfirmemailComponent } from './useraccess/confirmemail/confirmemail.component';
import { CreateschoolComponent } from './schools/createschool/createschool.component';
import {QuillModule} from 'ngx-quill';
import { SchoolhomeComponent } from './schools/schoolhome/schoolhome.component'
import { JwtInterceptorService } from './services/interceptor/jwt-interceptor.service';
import { AuthGuardGuard } from './authEngine/auth-guard.guard';
import { ModuleDetailsComponent } from './modules/details/details.component';
import { AssessmentconsoleComponent } from './assessments/assessmentconsole/assessmentconsole.component';
import { AssessmentdetailsComponent } from './assessments/assessmentdetails/assessmentdetails.component';
import { AssesmentFrameComponent } from './assessments/frame/frame.component';
import { AddquestionComponent } from './assessments/addquestion/addquestion.component';
import { BufferComponent } from './assessments/buffer/buffer.component';
import { NewassessmentComponent } from './assessments/newassessment/newassessment.component';
import { ModuleComponent } from './modules/module/module.component';
import { ModulesComponent } from './modules/modules/modules.component';
import { ModuleeditorComponent } from './modules/moduleeditor/moduleeditor.component';
import { ClasslistComponent } from './class/classlist/classlist.component';
import { SchoolComponent } from './schools/school/school.component';
import { UserschoolsComponent } from './schools/userschools/userschools.component';
//import { AddAdminComponent } from './modules/add-admin/add-admin.component';
import { AdminUsersComponent } from './modules/adminusers/adminusers.component';
import { NotificationInterceptor } from './services/interceptor/notification.interceptor';
import { ClassnoteComponent } from './class/classnote/classnote.component';
import { ModuleMediaLibraryComponent } from './modules/media-library/media-library.component';
import { ModuleMediaLibraryUploadComponent } from './modules/media-library-upload/media-library-upload.component';
import { ModuleMediaComponent } from './modules/media/media.component';
import { ModuleMediaIframeComponent } from './modules/media-iframe/media-iframe.component';
import { ModuleMediaLibraryMediaComponent } from './modules/media-library-media/media-library-media.component';
import { ManageadminusersComponent } from './modules/manageadminusers/manageadminusers.component';
import { AdminUserComponent } from './modules/adminuser/adminuser.component';
import { AddExternalMediaComponent } from './class/add-external-media/add-external-media.component';
//import { SubdomainInterceptorService } from './services/interceptor/subdomain.interceptor';
import { IndexComponent } from './index/index.component';
import { LogoutComponent } from './useraccess/logout/logout.component';
import { ClassmaterialComponent } from './class/classmaterial/classmaterial.component';
import { CustomhtmlsanitizerPipe } from './pipes/customhtmlsanitizer.pipe';
import { StudentassessmentdetailsComponent } from './assessments/studentassessmentdetails/studentassessmentdetails.component';
import { AssessmentEditorComponent } from './assessments/assessment-editor/assessment-editor.component';
import { ExternalauthComponent } from './useraccess/externalauth/externalauth.component';
import { UserprofileComponent } from './user/userprofile/userprofile.component';
import { UserprofileeditorComponent } from './user/userprofileeditor/userprofileeditor.component';
import { AssessmentFileUploadComponent } from './assessments/assessment-file-upload/assessment-file-upload.component';
import { ScoreAssessmentComponent } from './assessments/score-assessment/score-assessment.component';
import { AssessmentSubmissionsComponent } from './assessments/assessment-submissions/assessment-submissions.component';
import { AssessmentEditorViewerComponent } from './assessments/assessment-editor-viewer/assessment-editor-viewer.component';
import { DataTablesModule } from 'angular-datatables';
import { AssessmentMarksheetComponent } from './assessments/assessment-marksheet/assessment-marksheet.component';
import { MomentTimezonePickerModule } from 'moment-timezone-picker';
import { DashboarduserassessmentdetailComponent } from './assessments/dashboarduserassessmentdetail/dashboarduserassessmentdetail.component';
import { ModuleslistitemComponent } from './modules/moduleslistitem/moduleslistitem.component';
import { ExternallinksdirectiveDirective } from './directives/externallinksdirective.directive';
import { StudentassessmentlistComponent } from './assessments/studentassessmentlist/studentassessmentlist.component';
import { FaqskinComponent } from './faq/faqskin/faqskin.component';
import { FaqhomeComponent } from './faq/faqhome/faqhome.component';
import { ResendverificationemailComponent } from './useraccess/resendverificationemail/resendverificationemail.component';
import { SchedulelivelessonComponent } from './class/schedulelivelesson/schedulelivelesson.component';
import { RecordvideoComponent } from './class/recordvideo/recordvideo.component';
import { ProgressCardComponent } from './reuseableui/progress-card/progress-card.component';
import { SchoolaccountdashboardComponent } from './schools/schoolaccountdashboard/schoolaccountdashboard.component';
//import { AccountinformationComponent } from './billing/accountinformation/accountinformation.component';
import { MyaccountbillsComponent } from './billing/myaccountbills/myaccountbills.component';
// import { BillingmenustripComponent } from './billing/billingmenustrip/billingmenustrip.component';
import { BilldetailsComponent } from './billing/billdetails/billdetails.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { TooltipDirective } from './directives/tooltip.directive';
import { AttendanceComponent } from './class/attendance/attendance.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE, DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';
import { SchoolstudentlistComponent } from './schools/schoolstudentlist/schoolstudentlist.component';
import { ModulestudentlistComponent } from './modules/modulestudentlist/modulestudentlist.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModulePackageComponent } from './modulepackage/module-package/module-package.component';
import { ModulePackageEditorComponent } from './modulepackage/module-package-editor/module-package-editor.component';
import { ModulePackagesComponent } from './modulepackage/module-packages/module-packages.component';
import { AccountdetailsComponent } from './billing/accountdetails/accountdetails.component';
import { SchoolplansComponent } from './billing/schoolplans/schoolplans.component';
//import { VcircleplansComponent } from './billing/vcircleplans/vcircleplans.component';
import { ModulePackageDetailsComponent } from './modulepackage/module-package-details/module-package-details.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccountsettingsComponent } from './billing/accountsettings/accountsettings.component';
import { Nl2brPipe } from './pipes/nl2br.pipe';
import { SchoolNotFoundComponent } from './school-not-found/school-not-found.component';
import { NotFoundComponent } from './schools/not-found/not-found.component';
import { SendMailComponent } from './schools/send-mail/send-mail.component';
import { CollectiondetailsComponent } from './collections/collectiondetails/collectiondetails.component';
import { ViewCourseAssessmentsComponent } from './assessments/view-course-assessments/view-course-assessments.component';
import { AddEventComponent } from './event/add-event/add-event.component';
import { ViewEventsComponent } from './event/view-events/view-events.component';
import { ViewCustomCssComponent } from './customisation/custom-css/custom-css.component';
import { ModuleBatchesComponent } from './modules/module-batches/module-batches.component';
import { ViewModuleBatchComponent } from './modules/view-module-batch/view-module-batch.component';
import { EventModalComponent } from './event/event-modal/event-modal.component';
import { CustomCertificateComponent } from './customisation/custom-certificate/custom-certificate.component';
import { CustomIndexComponent } from './customisation/custom-index/custom-index.component';
// import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from 'ngx-mat-datetime-picker';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CustomMomentDateTimeAdapter } from './models/customMomentDateTimeAdapter';
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { GoogleLoginProvider} from '@abacritt/angularx-social-login';
import { environment } from 'src/environments/environment';
import { ActivitylogComponent } from './activitylog/activitylog.component';
import { TablelayoutComponent } from './reuseableui/tablelayout/tablelayout.component';
import { TextReaderComponent } from './text-reader/text-reader.component';
import { AddstudentusersComponent } from './modules/addstudentusers/addstudentusers.component';
import { UnregisteredstudentsComponent } from './module/unregisteredstudents/unregisteredstudents.component';
import { UploadvcirclemediaComponent } from './modules/uploadvcirclemedia/uploadvcirclemedia.component';
//import { SampleVcircleIframeComponent } from './sample-vcircle-iframe/sample-vcircle-iframe.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MilestoneComponent } from './reuseableui/milestone/milestone.component';
import { NgChartsModule } from'ng2-charts';
import { InvitestudentComponent } from './modules/invitestudent/invitestudent.component';
import { EnrollfrominviteComponent } from './site/enrollfrominvite/enrollfrominvite.component';
import { CoursecalendarcardComponent } from './coursecalendarcard/coursecalendarcard.component';
import { BillingoverdueComponent } from './reuseableui/billingoverdue/billingoverdue.component';
import { PaymentiframeComponent } from './reuseableui/paymentiframe/paymentiframe.component';  

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TextReaderComponent,
    UsermodulesComponent,
    AllmodulesComponent,
    CreateComponent,
    DetailsComponent,
    ModuleDetailsComponent,
    FilesComponent,
    NotesComponent,
    VideosComponent,
    //EditComponent,
    DashboardComponent,
    LoginComponent,
    ForgotpasswordComponent,
    RegisterComponent,
    UseraccessskinComponent,
    ChangepasswordComponent,
    PasswordStrengthComponent,
    ConfirmemailComponent,
    ForumComponent,
    ForumtemplateComponent,
    CreateschoolComponent,
    SchoolhomeComponent,
    ModuleComponent,
    ModulesComponent,
    ModuleeditorComponent,
    ClasslistComponent,
    SchoolComponent,
    UserschoolsComponent,
    TablelayoutComponent,
    AssessmentconsoleComponent,
    AssessmentdetailsComponent,
    AssesmentFrameComponent,
    AddquestionComponent,
    BufferComponent,
    NewassessmentComponent,
    //AddAdminComponent,
    AdminUsersComponent,
    ClassnoteComponent,
    ModuleMediaLibraryComponent,
    ModuleMediaLibraryUploadComponent,
    ModuleMediaComponent,
    ModuleMediaIframeComponent,
    ModuleMediaLibraryMediaComponent,
    ManageadminusersComponent,
    AdminUserComponent,
    AddExternalMediaComponent,
    IndexComponent,
    LogoutComponent,
    ClassmaterialComponent,
    UserprofileComponent,
    UserprofileeditorComponent,
    ExternalauthComponent,
    CustomhtmlsanitizerPipe,
    StudentassessmentdetailsComponent,
    AssessmentEditorComponent,
    AssessmentFileUploadComponent,
    ScoreAssessmentComponent,
    AssessmentSubmissionsComponent,
    AssessmentEditorViewerComponent,
    AssessmentMarksheetComponent,
    DashboarduserassessmentdetailComponent,
    ModuleslistitemComponent,
    ExternallinksdirectiveDirective,
    StudentassessmentlistComponent,
    FaqskinComponent,
    FaqhomeComponent,
    ResendverificationemailComponent,
    SchedulelivelessonComponent,
    RecordvideoComponent,
    ProgressCardComponent,
    ResendverificationemailComponent,
    SchoolaccountdashboardComponent,
    //AccountinformationComponent,
    MyaccountbillsComponent,
    // BillingmenustripComponent,
    BilldetailsComponent,
    // TooltipDirective
    AttendanceComponent,
    SchoolstudentlistComponent,
    ModulestudentlistComponent,
    AccountdetailsComponent,
    SchoolplansComponent,
    //VcircleplansComponent,
    ModulePackageComponent,
    ModulePackageEditorComponent,
    ModulePackagesComponent,
    ModulePackageDetailsComponent,
    AccountsettingsComponent,
    Nl2brPipe,
    SchoolNotFoundComponent,
    NotFoundComponent,
    SendMailComponent,
    CollectiondetailsComponent,
    ViewCourseAssessmentsComponent,
    AddEventComponent,
    ViewEventsComponent,
    ViewCustomCssComponent,
    ModuleBatchesComponent,
    ViewModuleBatchComponent,
    EventModalComponent,
    CustomCertificateComponent,
    CustomIndexComponent,
    ActivitylogComponent,
    AddstudentusersComponent,
    UnregisteredstudentsComponent,
    UploadvcirclemediaComponent,
    MilestoneComponent,
    InvitestudentComponent,
    EnrollfrominviteComponent,
    CoursecalendarcardComponent,
    BillingoverdueComponent,
    PaymentiframeComponent,
    //SampleVcircleIframeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgSelectModule,
    DataTablesModule,
    HttpClientModule,
    NgxPageScrollCoreModule,
    NgxPageScrollModule,
    ReactiveFormsModule,
    FormsModule,
    PdfViewerModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction

          //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['link', 'image' /*, 'video'*/],

          ['clean'], // remove formatting button

          ['save'],
        ],
      },
    }),
    CommonModule,
    BrowserAnimationsModule,    
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    ToastrModule.forRoot(),
    MomentTimezonePickerModule,

    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxPaginationModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    SocialLoginModule,
    NgChartsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true,
    },
    { provide: DateTimeAdapter, useClass: CustomMomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },

    //  {
    //    provide: HTTP_INTERCEPTORS,
    //    useClass: SubdomainInterceptorService,
    //    multi: true
    //  },
    AuthGuardGuard,
    ForumService,
    DatePipe,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.googleClientId
            )
          }          
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
//platformBrowserDynamic().bootstrapModule(AppModule);
